import { useTranslation } from 'react-i18next';
import styles from './HelpPage.module.css';

interface Props {
  active: 'manual' | 'whats-new';
  onNavigate: (path: string) => void;
}

/**
 * Manual / What's New segmented toggle, shared by the Help table of contents
 * and the What's New changelog so the switch reads the same on both pages.
 * Each tab navigates to its route; the active tab reflects the page you are
 * on. Same pill chrome as HistoryPage's tab switcher.
 */
export function HelpTabs({ active, onNavigate }: Props) {
  const { t } = useTranslation('help');
  return (
    <div className={styles.tabRow} role="tablist" aria-label={t('tabs.aria')}>
      <button
        type="button"
        role="tab"
        aria-selected={active === 'manual'}
        className={`${styles.tabBtn} ${active === 'manual' ? styles.tabBtnActive : ''}`}
        onClick={() => onNavigate('/help')}
      >
        {t('tabs.manual')}
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={active === 'whats-new'}
        className={`${styles.tabBtn} ${active === 'whats-new' ? styles.tabBtnActive : ''}`}
        onClick={() => onNavigate('/help/whats-new')}
      >
        {t('tabs.whatsNew')}
      </button>
    </div>
  );
}
